import tw, { styled } from 'twin.macro';

const ContainerAction = styled.div`
  ${tw`p-4 -mx-6 mt-6 -mb-6 bg-gray-50 text-right flex items-end justify-end sm:px-6
`}
`;

export default ContainerAction;
